import React from "react";

import { HoneybadgerErrorBoundary } from "@honeybadger-io/react";
import IncludeHUI from "Intuit/IncludeHUI";
import isIntuit from "Intuit/isIntuit";
import Helmet from "react-helmet";

import GenericErrorPage from "./GenericErrorPage";
import installHoneybadger from "./snippets/honeybadger";
import { bem } from "./styles";

const honeybadger = installHoneybadger();

type Props = {
  children: React.ReactNode;
};

const Page = ({ children }: Props) => (
  <HoneybadgerErrorBoundary honeybadger={honeybadger} ErrorComponent={GenericErrorPage}>
    <div>
      <Helmet titleTemplate="SimplyInsured - %s" defaultTitle="SimplyInsured">
        <body className={bem("Page")} />
      </Helmet>
      {isIntuit() && <IncludeHUI />}
      {children}
    </div>
  </HoneybadgerErrorBoundary>
);

export default Page;
